export const SUBJECT_ACTIONS = {
  SET_STATE: 'subject/setState',
  GET_SUBJECTS: 'subject/getSubjects',
  GET_SUBJECT_BY_ID: 'subject/getSubjectById',
  DESTROY: "subject/destroy"
};
